import { render, staticRenderFns } from "./Mfb.vue?vue&type=template&id=0b1559e8"
import script from "./Mfb.vue?vue&type=script&lang=js"
export * from "./Mfb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports